module.exports = __webpack_public_path__ + "media/images/icon_movie-18265d91.svg";